import { render } from "./RecovererForm.vue?vue&type=template&id=c7bc3fd2"
import script from "./RecovererForm.vue?vue&type=script&lang=js"
export * from "./RecovererForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__